// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__Kx5pU","forgot-password":"LoginForm_forgot-password__zaNXR","btn":"LoginForm_btn__3yOjs","input":"LoginForm_input__7Ngg7"};